
import { defineComponent } from "vue";

export default defineComponent({
  name: "BtnToggle",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    properties: {
      type: Object,
    },
    trueColor: {
      type: String,
      default: "primary",
    },
    trueIcon: {
      type: String,
      default: undefined,
    },
  },
  emits: ["update:value"],
  data() {
    return {
      v: this.value ?? false,
    };
  },
  computed: {
    propertiesComputed(): any {
      return {
        dense: true,
        color: "grey",
        ...this.properties,
        icon:
          (this.v
            ? this.trueIcon ?? this.properties?.icon
            : this.properties?.icon) ?? "circle",
      };
    },
  },
  watch: {
    value() {
      this.v = this.value;
    },
  },
  methods: {
    toggle() {
      this.v = !this.v;
      this.$emit("update:value", this.v);
    },
  },
});
